/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class Authentication {
  token: string;
  validTo: number;
  spsToken?: string;
  spsTokenValidTo?: number;
}
